import { SkillPlayer } from "./skill-player"
import { skillColors, type SkillName } from "./types/skillColors"

/**
 * класс секции Навыков
 */
export class Skills {
  private section: HTMLElement
  private skillsList: HTMLUListElement
  private skillsIcons: NodeListOf<SVGSVGElement>
  private skills: NodeListOf<HTMLInputElement>

  constructor(section: HTMLElement) {
    this.section = section
    this.skillsList = this.section.querySelector<HTMLUListElement>('ul.skills-list')!
    this.skillsIcons = this.skillsList.querySelectorAll<SVGSVGElement>('svg')
    this.skills = this.section.querySelectorAll<HTMLInputElement>('input[id|="skill"]')

    this.skillsIcons.forEach(icon =>
      icon.attributeStyleMap.set('color', skillColors[icon.dataset.title as SkillName])
    )
    const controlButton =
      this.section.querySelector<SVGSVGElement>('#play-control-skill')!
    new SkillPlayer(this.skills, controlButton, { skillColors })
  }
}


